{
  "connect_on_linkedin": "Connect with me on <0>LinkedIn</0>.",
  "contact": "Contact",
  "follow_on_github": "Follow me on <0>GitHub</0>.",
  "good_fit": "good fit for your company",
  "hello_message": {
    "after": "!",
    "before": "Hello, I'm ",
    "name": "Joel"
  },
  "im_a": "I'm a",
  "role_audio_enthusiast": "<0>audio</0> enthusiast",
  "role_full_stack_developer": "full stack <0>developer</0>",
  "role_musician": "<0>musician</0>",
  "role_oakland_graduate": "<0>Oakland</0> graduate",
  "role_oakland_student": "<0>Oakland</0> student",
  "role_open_source_contributor": "open-source <0>contributor</0>",
  "themes": {
    "dark": "Dark",
    "light": "Light",
    "system": "System"
  }
}
